import { ActionInfo } from "./ActionInfoTypes";

// -----
// *** SPLIT ACTIONS ***
// -----

export const Split_3005: ActionInfo = {
  id: "split_3005_into_3024",
  type: "Split",
  title: "Plate 1x1 (+3)",
  details: "+3 Plate 1x1",
  cost: [
    {
      brickId: "3005",
      baseChangeValue: 1,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3024",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3005",
    },
    {
      actionId: "auto_collect_3004",
    },
  ],
  isBrickpack: false,
};

export const Split_3004: ActionInfo = {
  id: "split_3004_into_3023",
  type: "Split",
  title: "Plate 1x2 (+3)",
  details: "+3 Plate 1x2",
  cost: [
    {
      brickId: "3004",
      baseChangeValue: 1,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3023",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3005",
    },
    {
      actionId: "auto_collect_3004",
    },
  ],
  isBrickpack: false,
};

export const Split_3010: ActionInfo = {
  id: "split_3010_into_3710",
  type: "Split",
  title: "Plate 1x4 (+3)",
  details: "+3 Plate 1x4",
  cost: [
    {
      brickId: "3010",
      baseChangeValue: 1,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3710",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3710",
    },
    {
      actionId: "increase_capacity_3710",
    },
  ],
  isBrickpack: false,
};

export const Split_3003: ActionInfo = {
  id: "split_3003_into_3022",
  type: "Split",
  title: "Plate 2x2 (+3)",
  details: "+3 Plate 2x2",
  cost: [
    {
      brickId: "3003",
      baseChangeValue: 1,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3022",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3022",
    },
    {
      actionId: "increase_capacity_3022",
    },
  ],
  isBrickpack: false,
};

export const Split_3001: ActionInfo = {
  id: "split_3001_into_3020",
  type: "Split",
  title: "Plate 2x4 (+3)",
  details: "+3 Plate 2x4",
  cost: [
    {
      brickId: "3001",
      baseChangeValue: 1,
    },
  ],
  costIncrement: 1,
  outcome: [
    {
      brickId: "3020",
      baseChangeValue: 3,
    },
  ],
  actionVisibility: [
    {
      actionId: "auto_collect_3020",
    },
    {
      actionId: "increase_capacity_3020",
    },
  ],
  isBrickpack: false,
};
